// @ts-nocheck
import { plugin } from './plugin';
import * as Plugin_0 from 'D:/CloudPatrolUI/Mayun.UI/node_modules/umi-plugin-antd-icon-config/lib/app.js';
import * as Plugin_1 from 'D:/CloudPatrolUI/Mayun.UI/src/.umi-production/plugin-dva/runtime.tsx';
import * as Plugin_2 from '../plugin-initial-state/runtime';
import * as Plugin_3 from 'D:/CloudPatrolUI/Mayun.UI/src/.umi-production/plugin-locale/runtime.tsx';
import * as Plugin_4 from '../plugin-model/runtime';

  plugin.register({
    apply: Plugin_0,
    path: 'D:/CloudPatrolUI/Mayun.UI/node_modules/umi-plugin-antd-icon-config/lib/app.js',
  });
  plugin.register({
    apply: Plugin_1,
    path: 'D:/CloudPatrolUI/Mayun.UI/src/.umi-production/plugin-dva/runtime.tsx',
  });
  plugin.register({
    apply: Plugin_2,
    path: '../plugin-initial-state/runtime',
  });
  plugin.register({
    apply: Plugin_3,
    path: 'D:/CloudPatrolUI/Mayun.UI/src/.umi-production/plugin-locale/runtime.tsx',
  });
  plugin.register({
    apply: Plugin_4,
    path: '../plugin-model/runtime',
  });
